/**
 * Pagination constants for Content V3 components
 */
export const PAGINATION_CONSTANTS = {
  DEFAULT_PAGE_SIZE: 20,
  SMALL_PAGE_SIZE: 10,
  LARGE_PAGE_SIZE: 50,
} as const;
